import { Injectable, inject } from "@angular/core";
import { Store } from "@ngxs/store";
import { ApplicationState } from "@vp/data-access/application";
import { FormStateProvider } from "@vp/formly/ui-schema-config";
import { of } from "rxjs";

@Injectable()
export class CurrentUserFormStateProviderService implements FormStateProvider {
  private store = inject(Store);

  provide(state: Record<string, unknown>) {
    if (state?.currentUser) {
      const currentUser = this.store.selectSnapshot(ApplicationState.loggedInUser);
      return of({ currentUser });
    }
    return of({});
  }
}
